import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
    apiKey: "AIzaSyBg6FNEeEvLZA7YAyF19sWYofzgp1uMw48",
    authDomain: "pastita-73697.firebaseapp.com",
    projectId: "pastita-73697",
    storageBucket: "pastita-73697.firebasestorage.app",
    messagingSenderId: "292077403889",
    appId: "1:292077403889:web:ea478d51eed6a0f7a4f350",
    measurementId: "G-VC2XPY5NXM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);

export { db, storage };
